import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators';
import {normalizeStyles} from '@webs/components-library/theming';

@customElement('webs-subfooter')
export class Subfooter extends LitElement {

  static styles = [
    normalizeStyles,
    css`
      hr {
        background: var(--color-light-grey);
        border: 0;
        opacity: 0.2;
        height: 1px;
        margin: 0 0 1.2rem;
      }

      .social-links {
        align-items: center;
        display: flex;
        padding-bottom: 1rem;
      }

      .footer-links {
        align-items: space-between;
        display: flex;
      }

      .footer-links ::slotted(*){
        align-items: baseline;
        display: flex;
        flex-wrap: wrap;
        margin: 0 -.75rem;
      }

      @media only screen and (min-width: 768px) {
        hr {
          margin: .6rem 0 1.75rem;
        }

        .social-links {
          justify-content: flex-end;
          padding-bottom: 0;
        }
      }
    `
  ];

  protected render(): unknown {
    return html`
      <hr>
      <webs-grid-row class="second-row" reverse="sm">
        <webs-grid-column sm="6" class="social-links">
          <slot name="social-links"></slot>
        </webs-grid-column>
        <webs-grid-column sm="6" class="footer-links">
          <slot name="subfooter-items"></slot>
        </webs-grid-column>
      </webs-grid-row>
    `
  }
}
